import React from 'react';
import { Skeleton } from '@patternfly/react-core';

const BreadcrumbSkeleton = () => {
  return <Skeleton width={'100px'} />;
};

export default BreadcrumbSkeleton;
